import React from "react";
import { useEffect } from "react";
import { Alert, Button, Card, Heading, Loader, Text, View } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { FaceLivenessDetector } from '@aws-amplify/ui-react-liveness';
import {v4} from 'uuid'

function FaceLivenessCustom({faceLivenessAnalysis, tryAgain}) {
    const [loading, setLoading] = React.useState(true);
    const [sessionId, setSessionId] = React.useState(null)
   
    const url = 'https://d2wy6f5rfc3jf3.cloudfront.net/api/liveness';

   /*
   * Create the Face Liveness Session
   */
   const fetchCreateLiveness = async () => {
      const body = {
        eventId: v4()
      };
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });
      const data = await response.json();
      console.log(`sessionId: ${data.sessionId}`);
      setSessionId(data.sessionId)
      setLoading(false);

    };

    useEffect(() => {
        fetchCreateLiveness();
    },[])

   /*
   * Get the Face Liveness Session Result
   */
    const handleAnalysisComplete = async () => {
        const response = await fetch(`${url}/${sessionId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });
        const data = await response.json();
        faceLivenessAnalysis(data)
    };

    const handleError = async (livenessError) => {
      console.log(livenessError);
    }

    const handleClick = () => {
      setSessionId(null);
      setLoading(true);
      fetchCreateLiveness();
      tryAgain();
    }

    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <FaceLivenessDetector
                    sessionId={sessionId}
                    region="us-east-1"
                    onAnalysisComplete={handleAnalysisComplete}
                    onError={(livenessError) => handleError(livenessError)}
                    components={{
                      Header: () => {
                        return (
                          <View flex="1">
                            <Heading>Face Liveness check - Edited</Heading>
                            <Text>
                              You will go through a face verification process to prove that
                              you are a real person. - Edited
                            </Text>
                          </View>
                        );
                      },
                      PhotosensitiveWarning: (): JSX.Element => {
                        return (
                          <Alert
                            variation="warning"
                            isDismissible={false}
                            hasIcon={true}
                            heading="Caution"
                          >
                            This check displays colored lights. Use caution if you are
                            photosensitive. - Edited
                          </Alert>
                        );
                      },
                      Instructions: (): JSX.Element => {
                        return (
                          <Card variation="elevated">
                            Instructions to follow to use Face Liveness detector - Edited
                            <ol>
                              <li>
                                Make sure your face is not covered with sunglasses or a mask. - Edited
                              </li>
                              <li>
                                Move to a well-lit place that is not dark or in direct
                                sunlight. - Edited
                              </li>
                              <li>
                                Fill onscreen oval with your face and hold for colored lights. - Edited
                              </li>
                            </ol>
                          </Card>
                        );
                      },
                      ErrorView: ({ children }) => {
                        return (
                          <View flex="1" backgroundColor="white" className="amplify-flex amplify-liveness-overlay amplify-liveness-overlay-opaque">
                            <div className="amplify-liveness-toast amplify-liveness-toast--default amplify-liveness-toast--medium">
                              <div className="amplify-flex amplify-liveness-toast__container">
                                {children}
                                <div className="amplify-flex">
                                  <Button className="amplify-button amplify-field-group__control amplify-button--primary" data-fullwidth="false" data-variation="primary" type="button" onClick={handleClick}>Try again</Button>
                                </div>
                              </div>
                            </div>
                          </View>
                        );
                      },
                    }}                
                />
            )}
        </>
    );
}

export default FaceLivenessCustom;
